import LightSpeedIn from './light-speed-in'
import LightSpeedOut from './light-speed-out'

export default {
  LightSpeedIn,
  LightSpeedOut
}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/light-speed/index.js